import {Service, ServiceInitState} from '@/store/service/service.types';
import {ServiceMutations} from '@/store/service/service.mutations';
import {ServiceAction} from '@/store/service/service.actions';

const namespaced = true;

export const serviceInitState: ServiceInitState = {
  service: [{}] as Service[]
};

export const serviceState = {
  namespaced,
  state: serviceInitState,
  actions: ServiceAction,
  mutations: ServiceMutations,
  // getters
};
